/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Clear_Tiger_WaveInputs */

const en_tall_clear_tiger_wave = /** @type {(inputs: Tall_Clear_Tiger_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred Channel`)
};

const de_tall_clear_tiger_wave = /** @type {(inputs: Tall_Clear_Tiger_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugter Kanal`)
};

/**
* | output |
* | --- |
* | "Preferred Channel" |
*
* @param {Tall_Clear_Tiger_WaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_clear_tiger_wave = /** @type {((inputs?: Tall_Clear_Tiger_WaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Clear_Tiger_WaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_clear_tiger_wave(inputs)
	return de_tall_clear_tiger_wave(inputs)
});